<template>
  <div class="class-home">
    <!-- 注册会计师 -->
    <iframe width="100%" height="100%" src="https://zzk.fhiedu.com/user/kdmt;year=2023;subject=12131;questionNumber=undefined;productId=85" frameborder="0"></iframe>
    <el-dialog top="12vh" title="" :visible.sync="dialogFormVisible" append-to-body class="mask-dialog" :close-on-click-modal="false" :show-close="false">
      <div style="text-align:center;padding-left:6%"><img style="width:90%" src="../assets/images/mask-img.png" alt="" ></div>
      <el-form ref="form" :model="form" class="form-wrap" :rules="rules">
        <div class="form-title">教授领衔  全博师资</div>
        <el-form-item prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center;margin-top:40px;margin-bottom:0">
          <el-button :loading="submitFlag" type="warning" round class="submit-btn" @click="submitHandle">立即登录听课</el-button>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <i class="el-icon-close" style="color:#fff;font-size:36px"></i>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapState, mapActions } from "vuex";
export default {
  name: "Class",
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      form:{
        name:'',
        phone:''
      },
      submitFlag:false,
      dialogFormVisible:true
    };
  },
  created() {
    if(localStorage.getItem('lp')){
      this.dialogFormVisible = false;
    }
  },
  methods: {
    ...mapActions(["classLogin"]),
    submitHandle(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submitFlag = true;
          // 数值：1. 注册会计师 2. 税务师 3. 中级经济师 4. 中级会计师
          this.form.type = 1
          this.classLogin(this.form).then(res=>{
            if(res.data && res.data.code==200){
              localStorage.setItem("lp", this.form.phone)
              this.$message({
                showClose: true,
                message: '登录成功！',
                type: 'success'
              });
              this.dialogFormVisible = false;
            }
          }).finally(()=>{
            this.submitFlag = false;
          })
        } else {
          return false;
        }
      });
    }

  },

  mounted() {
    document.title = "试听课"; 
  }
};
</script>
<style lang="scss">
.class-home{
  width: 100%;
  height: 100vh;
  position: fixed;
} 
.mask-dialog {
  .el-dialog{
    background-color: transparent !important;
    box-shadow:none !important
  }
  .el-dialog__body{
    padding:0
  }
  .el-dialog__header{
    display: none;
  }
  .el-dialog__footer{
    text-align: center;
  }
}
.form-wrap{
  padding: 20px;
  background-color: #fff;
  border-radius: 30px;
  margin-top:-8px;
  position: relative;
  .form-title{
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    color: #FF722C;
    text-align: center;
  }
  .el-input__inner{
    border-radius: 40px;
  }
  .submit-btn{
    width: 80%;
    margin: 0 auto;
    background: linear-gradient(0deg, #FF6D27, #FFD483);
  }
  .el-input.is-active .el-input__inner, .el-input__inner:focus{
    border-color: #FF6D27;
  }
  
}
</style>
